import { useMemo } from 'react';
import useSWR from 'swr';
import { getGroupSalesDraftSourceUrl } from '@/constant/approval';
import { getNestedDataFetcher } from '@/utils/apis';
import {
  buildGroupSalesShopOptions,
  type GroupSalesDraftSource,
} from '@/utils/approval/groupSales';

/** 단체판매(61·131) 매장 드롭다운 — 브랜드 전체조회 결과에 나온 매장(신청 건이 있는 매장만) */
const useGroupSalesShopOptions = (
  brandCode: string,
  buildUrl: (params: {
    brandCode: string;
    searchType: '2';
  }) => string = getGroupSalesDraftSourceUrl,
) => {
  const { data, error, isLoading } = useSWR<
    Pick<GroupSalesDraftSource, 'display'>
  >(
    brandCode ? buildUrl({ brandCode, searchType: '2' }) : null,
    getNestedDataFetcher,
    { revalidateOnFocus: false },
  );
  const options = useMemo(
    () => buildGroupSalesShopOptions(data?.display.candidates ?? []),
    [data],
  );
  return { options, error, isLoading };
};

export default useGroupSalesShopOptions;
